function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M242.5,485.1c-61.9,0-124-23.6-171.1-70.8C25.7,368.5,0.5,307.8,0.5,243S25.7,117.4,71.4,71.8 c94.5-94.3,248-94.3,342.4,0l0,0c94.3,94.6,94.3,248.3,0,342.5C366.7,461.5,304.5,485.1,242.5,485.1z"
}), React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  id: "_x30_3_00000062896020912518688530000006890573389299559069_"
}, React.createElement("path", {
  fill: "#603981",
  d: "M410.4,411c-92.8,92.7-243.1,92.7-335.9,0c-92.7-92.7-92.7-243.1,0-335.9c92.7-92.7,243.1-92.7,335.9,0 C503.2,167.9,503.2,318.3,410.4,411z"
})), React.createElement("g", {
  id: "_x30_3_00000060715261917288874390000004276944275740136353_"
}, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M413.6,243.9c0,95.8-77.7,173.5-173.5,173.5c-95.8,0-173.5-77.7-173.5-173.5c0-95.8,77.7-173.5,173.5-173.5 C335.9,70.4,413.6,148.1,413.6,243.9z"
})), React.createElement("g", {
  id: "_x30_3_00000034071334234932302970000010134052819969964457_"
}, React.createElement("path", {
  fill: "#6D3684",
  d: "M240.1,411.6c-92.5,0-167.7-75.2-167.7-167.7c0-92.5,75.2-167.7,167.7-167.7c92.5,0,167.7,75.2,167.7,167.7 C407.8,336.3,332.6,411.6,240.1,411.6z M240.1,81.2c-89.7,0-162.7,73-162.7,162.7c0,89.7,73,162.7,162.7,162.7 s162.7-73,162.7-162.7C402.8,154.2,329.8,81.2,240.1,81.2z"
})))), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M122,91.1l0.6-6.5c3.8,0.3,7.1-0.2,10.2-2.2c2.4-1.6,3.2-3.6,2.1-5.1l-0.1-0.1c-1-1.5-2.5-1.6-7.7,0.3 c-6.3,2.3-10.8,3.2-14.4-2l-0.1-0.1c-3.3-4.8-1.7-10.7,3.8-14.4c3.9-2.7,8-3.7,12.2-3.4V64c-3.5,0-6.5,0.6-8.7,2.1 c-2.2,1.5-2.7,3.4-1.8,4.7l0.1,0.1c1.2,1.7,2.7,1.5,8.1-0.5c6.4-2.3,10.7-2.5,13.9,2.2l0.1,0.1c3.6,5.3,1.7,11-4.1,15 C132.1,90.4,127.1,91.8,122,91.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M144.9,52l-8.8,4.3l-2.9-5.9l24-11.8l2.9,5.9l-8.8,4.3l11.3,23.1l-6.4,3.1L144.9,52z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M172.2,33.1l6.2-2l23,26.8l-7.1,2.2l-5-6l-13,4.1l-0.6,7.8l-6.9,2.2L172.2,33.1z M185.1,49l-7.3-8.7 l-0.9,11.3L185.1,49z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M201.1,25.4l6.5-0.8l17.4,17.9l-2.4-19.7l7-0.9l3.9,32l-6,0.7l-18-18.5l2.5,20.4l-7,0.9L201.1,25.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M241.9,21.6l12.6,0.8c10.1,0.6,16.7,8,16.1,17l0,0.1c-0.5,9.1-8,15.7-18.1,15.1l-12.6-0.8L241.9,21.6z  M248.6,28.4l-1.2,19.4l5.5,0.3c5.8,0.4,9.9-3.3,10.3-9l0-0.1c0.3-5.7-3.3-9.9-9.1-10.3L248.6,28.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M290.5,27l6.4,1.5l5.9,34.8l-7.2-1.7l-1.2-7.7l-13.3-3.2l-4.5,6.4l-7-1.7L290.5,27z M293.4,47.2l-1.8-11.2 l-6.6,9.2L293.4,47.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M319.1,35.3l13.5,5.9c3.8,1.6,6.2,4,7.3,6.8c0.9,2.4,0.8,5.1-0.4,7.9l0,0.1c-2.1,4.8-6,6.6-10.3,6.4l2.6,13.7 l-7.6-3.3l-2.2-12.2l-5.1-2.2l-4.1,9.5l-6.5-2.8L319.1,35.3z M325.9,55.4c3.2,1.4,5.7,0.5,6.8-2l0-0.1c1.2-2.8-0.1-5.1-3.3-6.5 L323,44l-3.7,8.5L325.9,55.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M353.2,51.3l10.5,7c8.4,5.6,10.4,15.3,5.3,22.9l-0.1,0.1c-5,7.5-14.8,9.5-23.2,3.9l-10.5-7L353.2,51.3z  M355.6,60.5l-10.8,16.2l4.6,3c4.8,3.2,10.3,2.1,13.4-2.6l0.1-0.1c3.2-4.8,2.1-10.3-2.7-13.5L355.6,60.5z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#603981",
  d: "M102.5,248.4v-0.2c0-18.8,14.4-33.5,33.9-33.5c13.2,0,21.6,5.5,27.4,13.4l-13.4,10.4 c-3.7-4.5-7.9-7.6-14.1-7.6c-9,0-15.4,7.7-15.4,17.1v0.2c0,9.7,6.4,17.2,15.4,17.2c6.7,0,10.7-3.1,14.6-7.8l13.4,9.6 c-6.1,8.4-14.3,14.6-28.5,14.6C117.3,281.7,102.5,267.6,102.5,248.4L102.5,248.4z"
}), React.createElement("polygon", {
  fill: "#603981",
  points: "169.4,215.7 187.8,215.7 187.8,240 210.9,240 210.9,215.7 228.8,215.7 228.8,280.7 210.9,280.7 210.9,256 187.4,256 187.4,280.7 169.4,280.7 169.4,215.7  "
}), React.createElement("polygon", {
  fill: "#603981",
  points: "169.4,215.7 187.8,215.7 187.8,240 210.9,240 210.9,215.7 228.8,215.7 228.8,280.7 210.9,280.7 210.9,256 187.4,256 187.4,280.7 169.4,280.7 169.4,215.7  "
}), React.createElement("path", {
  fill: "#603981",
  d: "M306.5,271l9.9-11.9c6.4,5.1,13.4,7.7,20.9,7.7c4.9,0,7.4-1.7,7.4-4.4v-0.3c0-2.8-2.1-4.2-11-6.3 c-13.8-3.1-24.4-7-24.4-20.3v-0.4c0-11.9,9.4-20.5,24.8-20.5c10.9,0,19.4,2.9,26.3,8.5l-8.9,12.5c-5.9-4.2-12.3-6.3-17.9-6.3 c-4.3,0-6.4,1.7-6.4,4.1v0.3c0,3,2.2,4.3,11.3,6.3c14.9,3.2,24.1,8.1,24.1,20.2v0.3c0,13.1-10.4,21-26,21 C325.2,281.7,314.5,278.1,306.5,271L306.5,271z"
}), React.createElement("path", {
  fill: "#603981",
  d: "M358.3,236.6L358.3,236.6c0-4.5,3.6-8.3,8.2-8.3c4.6,0,8.2,3.7,8.2,8.2v0c0,4.5-3.6,8.2-8.2,8.2 C361.9,244.8,358.3,241.1,358.3,236.6L358.3,236.6z M372.6,236.6L372.6,236.6c0-3.4-2.6-6.3-6.2-6.3c-3.5,0-6.2,2.8-6.2,6.3v0 c0,3.4,2.6,6.2,6.2,6.2C369.9,242.8,372.6,240,372.6,236.6L372.6,236.6z M363.1,232.5h3.7c2,0,3.4,0.9,3.4,2.6 c0,1.2-0.6,2-1.6,2.4l1.8,2.6h-3l-1.4-2h-0.6v2h-2.4V232.5L363.1,232.5z M366.6,236.1c0.7,0,1-0.3,1-0.8c0-0.5-0.4-0.8-1-0.8h-1.2 v1.6H366.6L366.6,236.1z"
}), React.createElement("path", {
  fill: "#603981",
  d: "M233.4,280.7h19l4.6-11.6h24.8l4.6,11.6h19.5l-27.4-64.9h-17.7L233.4,280.7L233.4,280.7z M276.7,254.8h-14.6 l7.3-18.4L276.7,254.8L276.7,254.8z"
})));

var SvgChasStandard = function SvgChasStandard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "CHAS_Standard",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485 485.3",
    style: {
      enableBackground: "new 0 0 485 485.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasStandard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHAS Standard.aab9d041.svg";
export { ForwardRef as ReactComponent };